export default "__VITE_ASSET__Ck6_efjc__"